module.exports = __webpack_public_path__ + "img/pcb-shili2.149b2ae8.jpg";